// A4 세로 1장 — 거래처용 1면만 인쇄한다.
// (레거시 양식은 가로 1장에 보관용+거래처용 2면이었으나 2026-08-21 사용자 요청으로
//  정본 프로토타입과 같은 세로 1면으로 변경)

import { InvoiceCopy } from './invoice-copy';
import type {
  InvoiceDocumentDto,
  InvoiceDocumentRow,
} from './invoice-document-types';

interface InvoiceSheetProps {
  header: InvoiceDocumentDto['header'];
  tableTitle: string;
  rows: InvoiceDocumentRow[];
}

export function InvoiceSheet({ header, tableTitle, rows }: InvoiceSheetProps) {
  return (
    <div className='inv-sheet'>
      <InvoiceCopy
        header={header}
        tableTitle={tableTitle}
        rows={rows}
        copyLabel='거래처용'
      />
    </div>
  );
}
